import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class DavidsonsPendingsStaging extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Davidsons_Pendings._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "From Dealer",
				id: "ffl_name",
				/** @param {Davidsons_Pendings_Object} obj */
				accessor: obj => (obj.ffl_name)
			},
			{
				Header: "To FFL",
				id: "location",
				/** @param {Davidsons_Pendings_Object} obj */
				accessor: obj => (obj.locations.name)
			},
			{
				Header: "Date",
				id: "date",
				width: 100,
				/** @param {Davidsons_Pendings_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Number of Products",
				id: "count",
				/** @param {Davidsons_Pendings_Object} obj */
				accessor: obj => (obj.quantity_products ?? 'No Count Available')
			},
			{
				Header: 'Status',
				id: 'status',
				width: 200,
				/** @param {Davidsons_Pendings_Object} obj */
				accessor: obj => (obj.status === 'C' ? 'Completed' : (obj.status === 'Error' ? 'Failed' : 'Processing'))
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('In-Network Transfers', "")}
							{this.renderHeaderRight("In-Network Transfers", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
